import script from "./VmdSubmissions.vue?vue&type=script&setup=true&lang=js"
export * from "./VmdSubmissions.vue?vue&type=script&setup=true&lang=js"

import "./VmdSubmissions.vue?vue&type=style&index=0&id=660e3dd2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-660e3dd2"]])

export default __exports__